import React, { useState } from 'react';
import { X, CheckCircle, Smartphone } from 'lucide-react';
import './SubscriptionModal.css';

const SubscriptionModal = ({ onClose, onSubscribe, user }) => {
    const [phoneNumber, setPhoneNumber] = useState(user?.mpesa || user?.whatsapp || user?.phone || '');
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState('input'); // input | processing | waiting | success

    // Listen for real-time subscription update
    React.useEffect(() => {
        if (step === 'waiting' && user?.isSubscribed) {
            setIsLoading(false);
            setStep('success');
            setTimeout(() => {
                onSubscribe(); // Close modal or refresh
            }, 3000);
        }
    }, [user, step, onSubscribe]);

    const handlePay = async (e) => {
        e.preventDefault();
        if (!phoneNumber) return;

        setIsLoading(true);
        setStep('processing');

        // Call M-Pesa API
        const { initiateSTKPush } = await import('../services/MpesaService');

        let userId = user?.uid || user?.id;

        // Fallback to localStorage if user prop is missing
        if (!userId) {
            const storedUser = localStorage.getItem('yatsite_userData');
            if (storedUser) {
                const parsed = JSON.parse(storedUser);
                userId = parsed.uid || parsed.id;
            }
        }

        if (!userId) {
            alert("Please login first.");
            setIsLoading(false);
            return;
        }

        const result = await initiateSTKPush(phoneNumber, 300, userId, 'SUB');

        if (result.success) {
            alert(`M-Pesa STK Push sent to ${phoneNumber}. Please enter your PIN.`);
            setStep('waiting'); // Waiting for callback

            // Fallback timeout if callback never comes (transient failure or user cancel)
            // But do NOT set success. Just reset or show error.
            setTimeout(() => {
                if (step !== 'success') {
                    // check if still waiting
                    // We won't close it, just let user close or retry.
                    // Optionally check status API? For now, we rely on Firestore listener.
                }
            }, 60000);

        } else {
            alert("Failed: " + (result.message || result.error));
            setIsLoading(false);
            setStep('input');
        }
    };

    if (step === 'success') {
        return (
            <div className="modal-overlay">
                <div className="modal-content success-content">
                    <div className="success-icon-wrapper">
                        <CheckCircle size={48} color="white" />
                    </div>
                    <h2>Payment Successful!</h2>
                    <p>You now have full access.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-btn" onClick={onClose} disabled={isLoading}>
                    <X size={24} />
                </button>

                <div className="modal-header">
                    <div className="icon-badge">
                        <Smartphone size={28} />
                    </div>
                    <h2>Unlock Premium Access</h2>
                    <p>Subscribe to access WhatsApp chats and connect instantly.</p>
                </div>

                <div className="price-tag">
                    <span className="currency">Ksh.</span>
                    <span className="amount">300</span>
                </div>

                <form onSubmit={handlePay}>
                    <div className="form-group">
                        <label>M-Pesa Number</label>
                        <input
                            type="tel"
                            placeholder="0712 345 678"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="phone-input"
                            disabled={isLoading}
                        />
                    </div>

                    <button type="submit" className="pay-btn" disabled={!phoneNumber || isLoading}>
                        {isLoading ? (
                            <span className="loading-spinner">
                                {step === 'waiting' ? 'Waiting for Confirmation...' : 'Processing...'}
                            </span>
                        ) : (
                            'Pay Ksh. 300'
                        )}
                    </button>
                </form>

                <p className="secure-note">
                    Secure payment via M-Pesa. Instant activation.
                </p>
            </div>
        </div>
    );
};

export default SubscriptionModal;
